import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output } from '@angular/core';
import { AppConfig } from 'src/app/app.config';
import { HelpersService } from 'src/app/services/helpers.service';
import { Statuses } from 'src/app/enums/statuses.enum'
import { TranslateService } from '@ngx-translate/core';
import { JobcardService } from 'src/app/services/jobcard.service';
import { ServiceRequestService } from 'src/app/services';
import { ConfirmationService, MessageService } from 'primeng/api';
import { WorkshopJobcardCreateService } from '../workshop-jobcard-create.service';
import { WorkshopJobcardMessagingAttachmentsComponent } from './workshop-jobcard-messaging-attachments/workshop-jobcard-messaging-attachments.component';
import { WorkshopJobcardInternalExternalNotesComponent } from './workshop-jobcard-internal-external-notes/workshop-jobcard-internal-external-notes.component';
import { WorkshopJobcardTransferComponent } from './workshop-jobcard-transfer/workshop-jobcard-transfer.component';
// import { WorkshopJobcardCancelOptionsComponent } from './workshop-jobcard-cancel-options/workshop-jobcard-cancel-options.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChecklistService } from 'src/app/services/checklist.service';
import { WorkshopJobcardServiceChecklistsComponent } from './workshop-jobcard-service-checklists/workshop-jobcard-service-checklists.component';
import { WorkshopJobcardServiceWaiversComponent } from './workshop-jobcard-service-waivers/workshop-jobcard-service-waivers.component';
import { WorkshopJobcardCustomQuestionDetailsComponent } from '../workshop-jobcard-custom-questions/workshop-jobcard-custom-question-details/workshop-jobcard-custom-question-details.component';
import { NotificationService } from 'src/app/services/notification.service';
import { WorkshopJobcardCollectionsDeliveriesDetailsComponent } from '../workshop-jobcard-collecions-deliveries/workshop-jobcard-collections-deliveries-details/workshop-jobcard-collections-deliveries-details.component'
import { BroadcastService } from 'src/app/services/broadcast.service';
import { ReceiptTemplateService } from 'src/app/components/portal/bikeshop/receipt-template-designer/services/receipt-template.service';
import { SelectPrintTemplateModalComponent } from 'src/app/components/portal/bikeshop/receipt-template-designer/select-print-template-modal/select-print-template-modal.component';
import { first } from 'rxjs/operators';
import { WorkshopJobcardAuditTrailComponent } from './workshop-jobcard-audit-trail/workshop-jobcard-audit-trail.component';

@Component({
  selector: 'app-workshop-jobcard-live-updates',
  templateUrl: './workshop-jobcard-live-updates.component.html',
  styleUrls: ['./workshop-jobcard-live-updates.component.scss'],
  providers: [MessageService]
})
export class WorkshopJobcardLiveUpdatesComponent implements OnChanges {

  @Input() jobcard: any;
  @Input() serviceTypes: any[] = [];
  @Input() showNotesInline: boolean = false;
  @Input() goToMessaging: boolean = false;
  @Output() jobcardChange = new EventEmitter<any>();

  showStatusActions: boolean = false;
  jobActions: any[];
  statusList: any[] = this.appConfig.getStatusList();
  hasMessages: boolean = false;
  canMoveJobCard: boolean = false;
  otherShops: any[] = [];
  sendComms: boolean = true;
  updatingStatus: boolean = false;
  countryData: any = this.helpersService.getCountryData();
  //originalStatusID: any;
  // reopening: boolean = false;
  // markingCollected: boolean = false;
  hasMandatoryChecklistItems: boolean = false;
  hasChecklistItems: boolean = false;
  mandatoryChecklistItems: any[] = [];
  internalNotes: any;
  externalNotes: any;
  clientNotes: any;
  unreadMessages: number = 0;
  messages: any = [];
  isWaiversEnabled: boolean = false;
  partnerData = this.helpersService.getPartnerData();
  public canDeviceHover: boolean = true;
  notesPreview = {
    show: false,
    type: ''
  };
  collectionsPreview = {
    show: false
  };
  customQuestionsPreview = {
    show: false
  };
  messagingPreview = {
    show: false
  };

  // Toggle for inline notes display
  showInlineNotes: boolean = true;

  public showAuditTrail: boolean = false;

  // Touch event handling properties
  private touchTimeout: any;
  private touchStartTime: number = 0;
  private longPressTriggered: boolean = false;
  public isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  constructor(
    private appConfig: AppConfig,
    private helpersService: HelpersService,
    private translate: TranslateService,
    public jobcardService: JobcardService,
    private serviceRequest: ServiceRequestService,
    private messageService: MessageService,
    private workshopJobcardCreateService: WorkshopJobcardCreateService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private elementRef: ElementRef,
    private confirmationService: ConfirmationService,
    private checklistService: ChecklistService,
    private notificationService: NotificationService,
    public broadcastService: BroadcastService,
    private receiptTemplateService: ReceiptTemplateService,
  ) {

  }

  ngOnInit() {
    //this.originalStatusID = this.jobcard.statusID;
    this.checkCanMove();
    this.hasMandatoryChecklists();
    this.getJobCardNotes();
    this.getJobCardMessages();
    this.getJobCardWaiver();
    this.setCanDeviceHover();
    this.checkIfThereAreAuditItems();
  }

  ngOnChanges() {
    //this.createJobActions();
  }

  // createJobActions() {
  //   if (this.jobcard.isFitting) {
  //     this.jobActions = [
  //       {
  //         key: Statuses.FITTINGCOMPLETED,
  //         label: this.translate.instant('bikeshop.job_actions.job_completed'),
  //         id: 41,
  //       },
  //       {
  //         key: Statuses.CANCELED,
  //         label: this.translate.instant('bikeshop.job_actions.cancel_job'),
  //         id: 100,
  //       },
  //     ];
  //   } else {
  //     this.jobActions = this.appConfig.getJobActions();
  //     if (!this.helpersService.getPartnerData().ShowINeedHelp) {
  //       this.jobActions = this.jobActions.filter((x) => {
  //         return x.key != Statuses.INEEDHELP;
  //       });
  //     }
  //   }
  // }

  // getCurrentStatusLabel() {
  //   var status = this.statusList.find(x => x.key === this.jobcard.statusID);
  //   return status ? status.label : 'Unknown Status';
  // }

  // getStatusStyle() {
  //   var status = this.statusList.find(x => x.key === this.jobcard.statusID);
  //   return status && status.styleClass ? status.styleClass : null;
  // }

  // getStatusIndicatorStyle(statusID) {
  //   var status = this.statusList.find(x => x.key === statusID);
  //   return status && status.styleClass ? status.styleClass : null;
  // }


  // toggleStatusDropdown(event?: Event) {
  //   if (event) {
  //     event.stopPropagation(); // Prevent event bubbling to document
  //   }
  //   this.showStatusActions = !this.showStatusActions;
  // }

  // selectStatusOption(option) {
  //   if (option.key === 40 && this.hasMandatoryChecklistItems) return;

  //   this.originalStatusID = this.jobcard.statusID;
  //   //this.jobcard.statusID = option.key;
  //   this.showStatusActions = false;
  //   if (option.key === Statuses.CANCELED) {
  //     this.cancelJobCard();
  //   } else {
  //     this.workshopJobcardCreateService.updateJobCardStatus(this.jobcard, option.key, this.sendComms, this.messageService, this.translate)
  //   }

  // }

  getJobCardNotes() {
    this.jobcardService.getServiceNotes(this.jobcard.partnerID, this.jobcard.id).subscribe(
      (notes) => {
        this.internalNotes = notes.filter(note => note.noteType === 'INTERNAL').pop();
        this.externalNotes = notes.filter(note => note.noteType === 'EXTERNAL').pop();
        this.clientNotes = notes.filter(note => note.noteType === 'CLIENTNOTES').pop();
      });
  }

  openNotes(type) {
    const modalRef = this.modalService.open(WorkshopJobcardInternalExternalNotesComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'xxl'
    });

    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.selectedNoteType = type;
    modalRef.componentInstance.internalNotes = this.internalNotes;
    modalRef.componentInstance.externalNotes = this.externalNotes;
    modalRef.componentInstance.clientNotes = this.clientNotes;

    modalRef.result.then(
      (result) => {
        this.jobcardChange.emit({ ...this.jobcard });
        this.getJobCardNotes();
      },
      (onrejected) => {
        this.getJobCardNotes();
      },
    );
  }

  getJobCardMessages() {
    this.notificationService.getJobCardNotificationsV2(this.helpersService.getPartnerId(), this.jobcard.id).subscribe(results => {
      this.unreadMessages = results.filter(message => !message.MessageRead && message.Direction === 'Incoming').length;
      this.messages = results;
      if (this.goToMessaging) {
        this.goToMessaging = false;
        this.openMessages();
      }
    }, err => {
    });
  }

  openMessages() {
    const modalRef = this.modalService.open(WorkshopJobcardMessagingAttachmentsComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'xxl'
    });

    modalRef.componentInstance.jobcard = this.jobcard;

    modalRef.result.then(
      (result) => {
        this.jobcardChange.emit({ ...this.jobcard });
        this.getJobCardMessages();
      },
      (onrejected) => {
        this.getJobCardMessages();
      },
    );
  }

  printJobCard() {
    console.log('Print button clicked, loading templates...');
    // Load the template cache then check for active JOB_CARD templates.
    this.receiptTemplateService.refresh()
      //.pipe(first())
      .subscribe(() => {
        this.receiptTemplateService.getActiveTemplates('JOB_CARD')
          .pipe(first())
          .subscribe(activeTemplates => {
            if (activeTemplates.length > 0) {
              this.openTemplatePrintModal(activeTemplates);
            } else {
              // No active receipt templates — fall back to the existing print path.
              this.openLegacyPrint();
            }
          });
      });
  }

  private openTemplatePrintModal(activeTemplates: any[]): void {
    console.log('Active templates found:', activeTemplates);
    const modalRef = this.modalService.open(SelectPrintTemplateModalComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'lg',
    });

    modalRef.componentInstance.templates = activeTemplates;

    modalRef.result.then(
      (selectedTemplateId: string) => {
        const win = window.open(
          `/store/receipt-templates/print/${selectedTemplateId}/${this.jobcard.id}`,
          '_blank',
        );
        if (win) win.focus();
      },
      () => { /* dismissed — do nothing */ },
    );
  }

  private openLegacyPrint(): void {
    const url = this.helpersService.getPrinterType() === 'A4'
      ? `/print/${this.jobcard.id}`
      : `/print-till-slip/${this.jobcard.id}`;
    const win = window.open(url, '_blank');
    if (win) win.focus();
  }

  moveJobCard() {
    const modalRef = this.modalService.open(WorkshopJobcardTransferComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'md'
    });

    modalRef.componentInstance.jobcard = this.jobcard;
    modalRef.componentInstance.otherShops = this.otherShops;
    modalRef.componentInstance.messageService = this.messageService;

    modalRef.result.then(
      (result) => {
        this.jobcardChange.emit({ ...this.jobcard });
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.update_job_card.job_card.moved',
            { shopName: result.shopName },
          ),
        });
        setTimeout(() => {
          this.activeModal.dismiss('Cross click');
        }, 5000);
      },
      (onrejected) => {

      },
    );
  }

  // cancelJobCard() {
  //   const modalRef = this.modalService.open(WorkshopJobcardCancelOptionsComponent, {
  //     backdrop: true,
  //     backdropClass: 'jobcard-modal-popup-backdrop',
  //     windowClass: 'jobcard-modal-popup-window',
  //     size: 'md'
  //   });

  //   modalRef.componentInstance.jobcard = this.jobcard;
  //   modalRef.componentInstance.messageService = this.messageService;

  //   modalRef.result.then(
  //     (result) => {
  //       this.jobcardChange.emit({ ...this.jobcard });
  //       this.messageService.add({
  //         life: 5000,
  //         detail: this.translate.instant('bikeshop.modal.update_job_card.job_card.message_job_cancelled', { JobCardNo: this.jobcard.jobCardNo }),
  //       });
  //       setTimeout(() => {
  //         this.activeModal.dismiss('Cross click');
  //       }, 5000);
  //     },
  //     (onrejected) => {
  //       this.jobcard.statusID = this.originalStatusID;
  //     },
  //   );
  // }

  checkCanMove() {
    this.jobcardService
      .canJobCardMove(this.helpersService.getPartnerId(), this.jobcard.id)
      .subscribe(
        (result) => {
          if (result && result.length > 0) {
            this.canMoveJobCard = true;
            this.otherShops = result;
          }
        },
        (err) => { },
      );
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;

    if (this.showStatusActions && !this.elementRef.nativeElement.contains(target)) {
      this.showStatusActions = false;
    }

    // Check if any preview is currently showing
    const hasActivePreview = this.notesPreview.show || this.messagingPreview.show ||
      this.collectionsPreview.show || this.customQuestionsPreview.show;

    if (hasActivePreview && !this.elementRef.nativeElement.contains(target)) {
      console.log('Closing previews from click');
      this.hideAllPreviews();
    }
  }

  @HostListener('document:touchend', ['$event'])
  onDocumentTouchEnd(event: TouchEvent) {
    const target = event.target as HTMLElement;

    console.log('Document touchend triggered, target:', target.tagName, target.className);

    // Don't close if this was a long press that just finished
    if (this.longPressTriggered) {
      console.log('Ignoring touchend - long press was triggered');
      return;
    }

    // Check if any preview is currently showing
    const hasActivePreview = this.notesPreview.show || this.messagingPreview.show ||
      this.collectionsPreview.show || this.customQuestionsPreview.show;

    console.log('Has active preview:', hasActivePreview);

    if (hasActivePreview) {
      // Check if the touch target is outside our component
      const isOutsideComponent = !this.elementRef.nativeElement.contains(target);

      // Also check if it's not within any preview popup
      const previewPopup = target.closest('.notes-preview-popup, .messaging-preview-popup, .collections-preview-popup, .custom-questions-preview-popup');
      const isOutsidePreview = !previewPopup;

      console.log('Outside component:', isOutsideComponent, 'Outside preview:', isOutsidePreview);

      if (isOutsideComponent || isOutsidePreview) {
        console.log('Closing previews from touchend');
        this.hideAllPreviews();
        // Prevent the click event from also firing
        event.preventDefault();
      }
    }
  }

  // Helper method to hide all previews
  hideAllPreviews() {
    this.hideNotesPreview();
    this.hideMessagingPreview();
    this.hideCollectionsPreview();
    this.hideCustomQuestionsPreview();
  }

  // reopenJobCard() {
  //   this.confirmationService.confirm({
  //     key: 'jobcard',
  //     header: this.translate.instant(
  //       'bikeshop.modal.update_job_card.job_card.reopen_job_card',
  //     ),
  //     message: this.translate.instant(
  //       'bikeshop.modal.update_job_card.job_card.reopen_job_card_detail',
  //     ),
  //     acceptLabel: this.translate.instant('general.yes'),
  //     accept: () => {
  //       this.reopening = true;
  //       this.serviceRequest.reopenJobcard(this.jobcard.id).subscribe(
  //         (res) => {
  //           this.jobcard.statusID = res.StatusID;
  //           this.reopening = false;
  //           this.messageService.add({
  //             life: 5000,
  //             detail: this.translate.instant(
  //               'bikeshop.modal.update_job_card.job_card.message_job_card_reopened',
  //               { JobCardNo: this.jobcard.jobCardNo },
  //             ),
  //           });
  //         },
  //         (err) => {
  //           this.reopening = false;
  //         },
  //       );
  //     },
  //     rejectLabel: this.translate.instant('general.no'),
  //   });
  // }

  // markAsCollected() {

  //   this.markingCollected = true;
  //   this.serviceRequest
  //     .collect(this.jobcard.id, this.sendComms)
  //     .subscribe((jobcard) => {
  //       this.jobcard.statusID = jobcard.StatusID;
  //       this.markingCollected = false;
  //       this.messageService.add({
  //         life: 5000,
  //         detail: this.translate.instant('bikeshop.services.message_collected', { jobcard: this.jobcard.jobCardNo }),
  //       });
  //     }, err => {
  //       this.markingCollected = false;
  //     });
  // }

  hasMandatoryChecklists() {
    this.checklistService.getServiceChecklist(this.jobcard.partnerID, this.jobcard.id).subscribe(checklists => {
      this.mandatoryChecklistItems = checklists.filter(item => item.mandatory);
      var isComplete = this.mandatoryChecklistItems.filter(item => {
        if (item.controlType === "TRAFFICLIGHT") {
          return item.defaultValue;
        } else {
          return item.defaultValue || item.rearValue || item.frontValue;
        }
      }).length === this.mandatoryChecklistItems.length;
      this.hasMandatoryChecklistItems = !isComplete;
      this.broadcastService.sendMessage({ message: 'update-checklist-mandatory-status', hasMandatoryChecklistItems: this.hasMandatoryChecklistItems });
      this.hasChecklistItems = checklists.length > 0;
    });
  }


  openChecklists() {
    this.checklistService.getServiceChecklist(this.jobcard.partnerID, this.jobcard.id).subscribe(checklists => {
      const modalRef = this.modalService.open(WorkshopJobcardServiceChecklistsComponent, {
        backdrop: true,
        backdropClass: 'jobcard-modal-popup-backdrop',
        windowClass: 'jobcard-modal-popup-window',
        size: 'xxl'
      });

      modalRef.componentInstance.jobcard = this.jobcard;
      modalRef.componentInstance.checklists = checklists;

      modalRef.result.then(
        (result) => {
          setTimeout(() => {
            this.hasMandatoryChecklists();
          }, 500);

        },
        (onrejected) => {
          setTimeout(() => {
            this.hasMandatoryChecklists();
          }, 500);
        },
      );
    });
  }

  getJobCardWaiver() {
    this.serviceRequest.getJobCardWaiver(this.jobcard.partnerID, this.jobcard.id, this.jobcard.isFitting).subscribe((waivers: any) => {
      if (this.jobcard.isFitting) {
        this.isWaiversEnabled = waivers?.waiverConfig?.postFittingWaiverRequired ||
          waivers?.waiverConfig?.preFittingWaiverRequired;
        return;
      } else {
        this.isWaiversEnabled = waivers?.waiverConfig?.postServiceWaiverRequired ||
          waivers?.waiverConfig?.preServiceWaiverRequired;
        return;
      }
    });
  }

  openWaivers() {
    const modalRef = this.modalService.open(WorkshopJobcardServiceWaiversComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'xl'
    });

    modalRef.componentInstance.jobcard = this.jobcard;

    modalRef.result.then(
      (result) => {

      },
      (onrejected) => {

      },
    );
  }

  openCustomQuestions() {
    const modalRef = this.modalService.open(WorkshopJobcardCustomQuestionDetailsComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'xl'
    });
    var originalData = JSON.parse(JSON.stringify(this.jobcard.customQuestions));
    modalRef.componentInstance.jobcard = this.jobcard;

    modalRef.result.then(
      (result) => {
        this.jobcardChange.emit({ ...this.jobcard });
      },
      (onrejected) => {
        this.jobcard.customQuestions = originalData;
      },
    );
  }

  openBookingDetails() {

  }

  openCollectionDetails() {
    const modalRef = this.modalService.open(WorkshopJobcardCollectionsDeliveriesDetailsComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'lg'
    });

    modalRef.componentInstance.jobcard = JSON.parse(JSON.stringify(this.jobcard));

    modalRef.result.then(
      (result) => {
        if (result) {
          console.log(this.jobcard.collectionsDeliveries)
          console.log(result.collectionsDeliveries);
          this.jobcard = result;
          this.jobcardChange.emit({ ...this.jobcard });
          this.messageService.add({
            life: 2000,
            detail: this.translate.instant('bikeshop.modal.update_job_card.collections.collection_saved')
          });
        }
      },
      (onrejected) => {
        console.log('Modal dismissed:', onrejected);
      },
    );
  }

  // Touch event handlers for preview functionality
  onTouchStart(event: TouchEvent, previewType: string) {
    if (!this.isTouchDevice) return;

    // Clear any existing text selection
    if (window.getSelection) {
      window.getSelection()?.removeAllRanges();
    }

    this.touchStartTime = Date.now();
    this.longPressTriggered = false;

    this.touchTimeout = setTimeout(() => {
      this.longPressTriggered = true;

      // Add haptic feedback if available
      if (navigator.vibrate) {
        navigator.vibrate(50);
      }

      switch (previewType) {
        case 'notes-internal':
          this.showNotesPreview('INTERNAL');
          break;
        case 'notes-external':
          this.showNotesPreview('EXTERNAL');
          break;
        case 'notes-client':
          this.showNotesPreview('CLIENTNOTES');
          break;
        case 'messaging':
          this.showMessagingPreview();
          break;
        case 'collections':
          this.showCollectionsPreview();
          break;
        case 'custom-questions':
          this.showCustomQuestionsPreview();
          break;
      }
    }, 500); // 500ms long press
  }

  onTouchEnd(event: TouchEvent) {
    const touchDuration = Date.now() - this.touchStartTime;

    if (this.touchTimeout) {
      clearTimeout(this.touchTimeout);
      this.touchTimeout = null;
    }

    // If it was a long press, prevent the click event
    if (this.longPressTriggered) {
      event.preventDefault();
      event.stopPropagation();

      // Clear any text selection that might have occurred
      if (window.getSelection) {
        window.getSelection()?.removeAllRanges();
      }

      // Reset the long press flag after a short delay to allow next interaction
      setTimeout(() => {
        this.longPressTriggered = false;
      }, 100);
    }
  }

  onTouchMove(event: TouchEvent) {
    if (this.touchTimeout) {
      clearTimeout(this.touchTimeout);
      this.touchTimeout = null;
    }

    // Clear any text selection on move
    if (window.getSelection) {
      window.getSelection()?.removeAllRanges();
    }
  }

  // Button click handlers that check for long press
  onNotesButtonClick(noteType: string, event: Event) {
    if (this.longPressTriggered) {
      event.preventDefault();
      event.stopPropagation();
      this.longPressTriggered = false;
      return;
    }
    this.hideAllPreviews();
    this.openNotes(noteType);
  }

  onMessagingButtonClick(event: Event) {
    if (this.longPressTriggered) {
      event.preventDefault();
      event.stopPropagation();
      this.longPressTriggered = false;
      return;
    }
    this.hideAllPreviews();
    this.openMessages();
  }

  onCollectionsButtonClick(event: Event) {
    if (this.longPressTriggered) {
      event.preventDefault();
      event.stopPropagation();
      this.longPressTriggered = false;
      return;
    }
    this.hideAllPreviews();
    this.openCollectionDetails();
  }

  onCustomQuestionsButtonClick(event: Event) {
    if (this.longPressTriggered) {
      event.preventDefault();
      event.stopPropagation();
      this.longPressTriggered = false;
      return;
    }
    this.hideAllPreviews();
    this.openCustomQuestions();
  }

  showNotesPreview(type: string) {
    this.notesPreview = {
      show: true,
      type: type
    };

    // Position the popup after it's rendered
    setTimeout(() => this.positionPreview('.notes-preview-popup'), 0);
  }

  hideNotesPreview() {
    this.notesPreview = {
      show: false,
      type: ''
    };
  }

  showCollectionsPreview() {
    if (this.hasCollectionDeliveryData()) {
      this.collectionsPreview = {
        show: true
      };

      // Position the popup after it's rendered
      setTimeout(() => this.positionPreview('.collections-preview-popup'), 0);
    }
  }

  hideCollectionsPreview() {
    this.collectionsPreview = {
      show: false
    };
  }

  hasCollectionDeliveryData(): boolean {
    const collectionsDeliveries = this.jobcard?.collectionsDeliveries;
    if (!collectionsDeliveries) return false;

    const hasCollectionData = collectionsDeliveries.allowCollection &&
      collectionsDeliveries.collectionInfo &&
      (collectionsDeliveries.collectionInfo.fullAddress || collectionsDeliveries.collectionInfo.scheduleDate);

    const hasDeliveryData = collectionsDeliveries.allowDelivery &&
      collectionsDeliveries.deliveryInfo &&
      (collectionsDeliveries.deliveryInfo.fullAddress || collectionsDeliveries.deliveryInfo.scheduleDate);

    return hasCollectionData || hasDeliveryData;
  }

  showCustomQuestionsPreview() {
    if (this.hasCustomQuestionsData()) {
      this.customQuestionsPreview = {
        show: true
      };

      // Position the popup after it's rendered
      setTimeout(() => this.positionPreview('.custom-questions-preview-popup'), 0);
    }
  }

  hideCustomQuestionsPreview() {
    this.customQuestionsPreview = {
      show: false
    };
  }

  showMessagingPreview() {
    if (this.hasMessagesData()) {
      this.messagingPreview = {
        show: true
      };

      // Position the popup after it's rendered
      setTimeout(() => this.positionPreview('.messaging-preview-popup'), 0);
    }
  }

  hideMessagingPreview() {
    this.messagingPreview = {
      show: false
    };
  }

  hasMessagesData(): boolean {
    return this.messages && this.messages.length > 0;
  }

  hasCustomQuestionsData(): boolean {
    return this.jobcard?.customQuestions &&
      this.jobcard.customQuestions.length > 0 &&
      this.jobcard.customQuestions.some(group =>
        group.customQuestions &&
        group.customQuestions.length > 0 &&
        group.customQuestions.some(q => q.response !== null && q.response !== undefined && q.response !== '')
      );
  }

  positionPreview(popupSelector: string) {
    const popup = this.elementRef.nativeElement.querySelector(popupSelector);
    if (!popup) return;

    const buttonContainer = popup.closest('.notes-button-container, .collections-button-container, .custom-questions-button-container, .messaging-button-container');
    if (!buttonContainer) return;

    const buttonRect = buttonContainer.getBoundingClientRect();
    const popupRect = popup.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Default positioning
    let top = buttonRect.bottom + 8;
    let left = buttonRect.left;

    // For custom questions, position above the button
    if (popupSelector.includes('custom-questions')) {
      top = buttonRect.top - popupRect.height - 8;
    }

    // Adjust horizontal position to keep within viewport
    if (left + popupRect.width > viewportWidth - 20) {
      // If popup would overflow right edge, align it to the right edge of viewport
      left = viewportWidth - popupRect.width - 20;
    }

    if (left < 20) {
      // If popup would overflow left edge, align it to the left edge
      left = 20;
    }

    // Adjust vertical position if needed
    if (top + popupRect.height > viewportHeight - 20) {
      // Position above the button instead
      top = buttonRect.top - popupRect.height - 8;
    }

    if (top < 20) {
      // If still doesn't fit, position below with available space
      top = buttonRect.bottom + 8;
    }

    // Apply the calculated position
    popup.style.top = `${top}px`;
    popup.style.left = `${left}px`;
    popup.style.right = 'auto';
    popup.style.bottom = 'auto';
  }

  // updateItemIsHere(event) {
  //   this.jobcard.itemIsHere = event.checked;
  //   this.serviceRequest.updateWorkshopJobCard(this.jobcard).subscribe((result) => {
  //     if (!event.checked) {
  //       this.messageService.add({
  //         life: 5000,
  //         detail: this.translate.instant(
  //           'bikeshop.modal.update_job_card.job_card.message_undo_bike_received',
  //           { JobCardNo: this.jobcard.jobCardNo },
  //         ),
  //       });
  //       if (this.jobcard.statusID === 20) {
  //         this.serviceRequest
  //           .undoBikeReceived(this.jobcard.id)
  //           .subscribe((res) => {
  //             this.jobcard.statusID = res.StatusID;
  //           });
  //       }
  //     } else {
  //       this.messageService.add({
  //         life: 5000,
  //         detail: this.translate.instant(
  //           'bikeshop.modal.update_job_card.job_card.message_bike_received_and_assigned',
  //           { JobCardNo: this.jobcard.jobCardNo },
  //         ),
  //       });
  //       if (this.jobcard.statusID < 20) {
  //         this.serviceRequest
  //           .bikeReceived(this.jobcard.id, this.sendComms)
  //           .subscribe((res) => {
  //             this.jobcard.statusID = res.StatusID;
  //           });
  //       }
  //     }
  //   });
  // }

  // toggleItemIsHere() {
  //   if (this.jobcard.statusID >= 25 && this.jobcard.statusID != 35) {
  //     return; // Disabled state
  //   }

  //   // Create a synthetic event object to match the existing updateItemIsHere method
  //   const syntheticEvent = {
  //     checked: !this.jobcard.itemIsHere
  //   };

  //   this.updateItemIsHere(syntheticEvent);
  // }

  setCanDeviceHover() {
    if (window.matchMedia("(hover: hover)").matches) {
      this.canDeviceHover = true;
    } else if (window.matchMedia("(hover: none)").matches) {
      this.canDeviceHover = false;
    }
  }

  checkIfThereAreAuditItems() {
    this.jobcardService.getJobcardAudit(this.jobcard.partnerID, this.jobcard.id).subscribe(res => {
      console.log(res);
      if (res.length > 0)
        this.showAuditTrail = true;
      console.log(this.showAuditTrail);
    });
  }

  openAuditHistory() {
    const modalRef = this.modalService.open(WorkshopJobcardAuditTrailComponent, {
      backdrop: true,
      backdropClass: 'jobcard-modal-popup-backdrop',
      windowClass: 'jobcard-modal-popup-window',
      size: 'xl'
    });
    var originalData = JSON.parse(JSON.stringify(this.jobcard.customQuestions));
    modalRef.componentInstance.jobcard = this.jobcard;

    modalRef.result.then(
      (result) => {
        this.jobcardChange.emit({ ...this.jobcard });
      },
      (onrejected) => {
        this.jobcard.customQuestions = originalData;
      },
    );
  }

}
